export class MotorDriverMdl {
    public DriverNo: number;
    public DriverNameAr: string;
    public DriverNameEn: string;
    public DriverLicenseNo: string;
    public DriverIDType: string;
    public DriverLicenseType: string;
    public DriverMaritalStatus: string;
    public DriverNationality: string;
    public DriverDOB: string;
    public DriverLicIssueDate: string;
    public LangFlag: string;
    public Ismaindriver: string;
    public Drivergender: string;
    public DrivingExp: string;
    public Driver_dependents: string;
    public Drv_IsSmoker: string;
    public Driver_Age: string;
    public DriverLic_ExpiryDate: string;
    public Dr_Profession: string;
    public DriverLicenseTypeEn: string;
    public DriverLicenseTypeAr: string;
    public DriverNationalityEn: string;
    public DriverNationalityAr: string;
    public isMainDriverEn: string;
    public isMainDriverAr: string;
    public DriverMaritalStatusEn: string;
    public DriverMaritalStatusAr: string;
    public isInsured: boolean;
    public DriverAddress: string;
    public DriverCity: string;
    public DriverCityEn: string;
    public DriverCityAr: string;
    public DriverEducation: string;
    public DriverEducationEn: string;
    public DriverEducationAr: string;
    public DriverProfession: string;
    public DriverProfessionEn: string;
    public DriverProfessionAr: string;
    public DriverChildrenYears: string;
    public SaudiLicenceHeld: string;
    public OtherCountriesLicenceHeld: string;
    public OtherCountriesLicenceHeldEn: string;
    public OtherCountriesLicenceHeldAr: string;
    public DriverMedicalConditions: string;
    public NumberOfYearsEachCountry: string;
    public RelationWithInsured: string;


    public ResidenceAdditionalNumber: number;
    public ResidenceBuildingNumber: number;
    public ResidenceCity: number;
    public ResidenceDistrict: string;
    public ResidenceStreet: string;
    public ResidenceUnitNumber: number;
    public ResidenceZipCode: number;
    public ResidenceZone: string;

    public OfficeBuildingNumber: number;
    public OfficeCity: number;
    public OfficeDistrict: string;
    public OfficeStreet: string
    public OfficeUnitNumber: number;
    public OfficeZone: string;
    public OfficeZipCode: number;
    public OfficeAdditionalNumber: number;

    public RoadConvictions: number;
    public DriverUsagePercentage: number;
    public IsMandatory: number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorDriverMdl.ts